import { Component, EventEmitter, Input, Output } from '@angular/core';
import { fromRole, fromSize, Role, Size } from './../buttons-utils';

@Component({
    selector: 'a-button-cancel',
    templateUrl: './a-button-cancel.component.html',
    styleUrls: [
        './../buttons.scss',
        './a-button-cancel.component.scss'
    ],
    standalone: false
})

export class AButtonCancelComponent {
    @Input()
    public disabled = false;

    @Input()
    public size: Size = 'DEFAULT';

    @Input()
    public role: Role = 'DEFAULT';

    public fromSize = fromSize;
    public fromRole = fromRole;

    // tslint:disable-next-line:no-output-native
    @Output()
    public click: EventEmitter<MouseEvent> = new EventEmitter();

    constructor() {
    }

    public doAction(event: MouseEvent): void {
        event.stopPropagation();
        if (!this.disabled) {
            this.click.emit(event);
        }
    }

}
